export type LocationSeoLink = { name: string; url: string };
export type LocationSeoPage = {
  place: string;
  title: string;
  h1: string;
  description: string;
  areaType: "City" | "State";
  breadcrumbParent: LocationSeoLink | null;
  linksHeading: string;
  links: LocationSeoLink[];
  caseStudy?: { title: string; text: string; url: string };
};

// Exact October 12 Stage 1 values, independent of legacy keyword/location data.
export const locationSeoPages: Record<string, LocationSeoPage> = {
  "las-vegas-seo": {
  "place": "Las Vegas",
  "title": "Las Vegas Lawyer & Law Firm SEO | PageOne Lawyers",
  "h1": "Lawyer & Law Firm SEO in Las Vegas",
  "description": "Las Vegas lawyer and law firm SEO: rank in Las Vegas maps and search for the cases you want, with reporting on calls and signed cases.",
  "areaType": "City",
  "breadcrumbParent": null,
  "linksHeading": "Lawyer & Law Firm SEO Near Las Vegas",
  "links": []
},
  "scottsdale-seo": {
  "place": "Scottsdale",
  "title": "Scottsdale Lawyer & Law Firm SEO | PageOne Lawyers",
  "h1": "Lawyer & Law Firm SEO in Scottsdale",
  "description": "Scottsdale lawyer and law firm SEO: rank in Scottsdale maps and search for the cases you want, with reporting on calls and signed cases.",
  "areaType": "City",
  "breadcrumbParent": null,
  "linksHeading": "Lawyer & Law Firm SEO Near Scottsdale",
  "links": []
},
  "minneapolis-seo": {
  "place": "Minneapolis",
  "title": "Minneapolis Lawyer & Law Firm SEO | PageOne Lawyers",
  "h1": "Lawyer & Law Firm SEO in Minneapolis",
  "description": "Minneapolis lawyer and law firm SEO: rank in Minneapolis maps and search for the cases you want, with reporting on calls and signed cases.",
  "areaType": "City",
  "breadcrumbParent": null,
  "linksHeading": "Lawyer & Law Firm SEO Near Minneapolis",
  "links": []
},
  "kansas-city-seo": {
  "place": "Kansas City",
  "title": "Kansas City Lawyer & Law Firm SEO | PageOne Lawyers",
  "h1": "Lawyer & Law Firm SEO in Kansas City",
  "description": "Kansas City lawyer and law firm SEO: rank in Kansas City maps and search for the cases you want, with reporting on calls and signed cases.",
  "areaType": "City",
  "breadcrumbParent": null,
  "linksHeading": "Lawyer & Law Firm SEO Near Kansas City",
  "links": []
},
  "baltimore-seo": {
  "place": "Baltimore",
  "title": "Baltimore Lawyer & Law Firm SEO | PageOne Lawyers",
  "h1": "Lawyer & Law Firm SEO in Baltimore",
  "description": "Baltimore lawyer and law firm SEO: rank in Baltimore maps and search for the cases you want, with reporting on calls and signed cases.",
  "areaType": "City",
  "breadcrumbParent": null,
  "linksHeading": "Lawyer & Law Firm SEO Near Baltimore",
  "links": []
},
  "charlotte-seo": {
  "place": "Charlotte",
  "title": "Charlotte Lawyer & Law Firm SEO | PageOne Lawyers",
  "h1": "Lawyer & Law Firm SEO in Charlotte",
  "description": "Charlotte lawyer and law firm SEO: rank in Charlotte maps and search for the cases you want, with reporting on calls and signed cases.",
  "areaType": "City",
  "breadcrumbParent": null,
  "linksHeading": "Lawyer & Law Firm SEO Near Charlotte",
  "links": []
},
  "nashville-seo": {
  "place": "Nashville",
  "title": "Nashville Lawyer & Law Firm SEO | PageOne Lawyers",
  "h1": "Lawyer & Law Firm SEO in Nashville",
  "description": "Nashville lawyer and law firm SEO: rank in Nashville maps and search for the cases you want, with reporting on calls and signed cases.",
  "areaType": "City",
  "breadcrumbParent": null,
  "linksHeading": "Lawyer & Law Firm SEO Near Nashville",
  "links": []
},

  "arizona-seo": {
    "place": "Arizona",
    "title": "Arizona Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Arizona",
    "description": "Arizona lawyer and law firm SEO: rank across Arizona in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Cities We Cover in Arizona",
    "links": [
      {
        "name": "Phoenix",
        "url": "/lawyer-seo/phoenix-seo"
      },
      {
        "name": "Tucson",
        "url": "/lawyer-seo/tucson-seo"
      }
    ]
  },
  "arkansas-seo": {
    "place": "Arkansas",
    "title": "Arkansas Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Arkansas",
    "description": "Arkansas lawyer and law firm SEO: rank across Arkansas in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Arkansas",
    "links": []
  },
  "atlanta-seo": {
    "place": "Atlanta",
    "title": "Atlanta Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Atlanta",
    "description": "Atlanta lawyer and law firm SEO: rank in Atlanta maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Georgia",
      "url": "/lawyer-seo/georgia-seo"
    },
    "linksHeading": "More in Georgia",
    "links": [
      {
        "name": "Georgia",
        "url": "/lawyer-seo/georgia-seo"
      }
    ]
  },
  "austin-seo": {
    "place": "Austin",
    "title": "Austin Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Austin",
    "description": "Austin lawyer and law firm SEO: rank in Austin maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Texas",
      "url": "/lawyer-seo/texas-seo"
    },
    "linksHeading": "More in Texas",
    "links": [
      {
        "name": "Texas",
        "url": "/lawyer-seo/texas-seo"
      },
      {
        "name": "Houston",
        "url": "/lawyer-seo/houston-seo"
      },
      {
        "name": "Dallas",
        "url": "/lawyer-seo/dallas-seo"
      },
      {
        "name": "San Antonio",
        "url": "/lawyer-seo/san-antonio-seo"
      }
    ]
  },
  "boston-seo": {
    "place": "Boston",
    "title": "Boston Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Boston",
    "description": "Boston lawyer and law firm SEO: rank in Boston maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Near Boston",
    "links": [],
    "caseStudy": {
      "title": "Case Study: A Boston Estate Planning Firm",
      "text": "A traditional Boston estate planning firm grew wills, trusts and probate inquiries by 184% in 9 months by targeting high-complexity searches.",
      "url": "/case-studies/estate-planning-boston"
    }
  },
  "chicago-seo": {
    "place": "Chicago",
    "title": "Chicago Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Chicago",
    "description": "Chicago lawyer and law firm SEO: rank in Chicago maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Illinois",
      "url": "/lawyer-seo/illinois-seo"
    },
    "linksHeading": "More in Illinois",
    "links": [
      {
        "name": "Illinois",
        "url": "/lawyer-seo/illinois-seo"
      },
      {
        "name": "Peoria",
        "url": "/lawyer-seo/peoria-seo"
      }
    ],
    "caseStudy": {
      "title": "Case Study: A Chicago Family Law Firm",
      "text": "A Chicago family law firm expanded from Cook County into DuPage and Lake counties, reached the top 3 in all three, and grew divorce consultations by 248%.",
      "url": "/case-studies/family-law-chicago"
    }
  },
  "cleveland-seo": {
    "place": "Cleveland",
    "title": "Cleveland Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Cleveland",
    "description": "Cleveland lawyer and law firm SEO: rank in Cleveland maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Ohio",
      "url": "/lawyer-seo/ohio-seo"
    },
    "linksHeading": "More in Ohio",
    "links": [
      {
        "name": "Ohio",
        "url": "/lawyer-seo/ohio-seo"
      }
    ]
  },
  "connecticut-seo": {
    "place": "Connecticut",
    "title": "Connecticut Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Connecticut",
    "description": "Connecticut lawyer and law firm SEO: rank across Connecticut in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Connecticut",
    "links": []
  },
  "dallas-seo": {
    "place": "Dallas",
    "title": "Dallas Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Dallas",
    "description": "Dallas lawyer and law firm SEO: rank in Dallas maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Texas",
      "url": "/lawyer-seo/texas-seo"
    },
    "linksHeading": "More in Texas",
    "links": [
      {
        "name": "Texas",
        "url": "/lawyer-seo/texas-seo"
      },
      {
        "name": "Houston",
        "url": "/lawyer-seo/houston-seo"
      },
      {
        "name": "Austin",
        "url": "/lawyer-seo/austin-seo"
      },
      {
        "name": "San Antonio",
        "url": "/lawyer-seo/san-antonio-seo"
      }
    ]
  },
  "delaware-seo": {
    "place": "Delaware",
    "title": "Delaware Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Delaware",
    "description": "Delaware lawyer and law firm SEO: rank across Delaware in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Delaware",
    "links": []
  },
  "denver-seo": {
    "place": "Denver",
    "title": "Denver Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Denver",
    "description": "Denver lawyer and law firm SEO: rank in Denver maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Near Denver",
    "links": []
  },
  "florida-seo": {
    "place": "Florida",
    "title": "Florida Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Florida",
    "description": "Florida lawyer and law firm SEO: rank across Florida in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Cities We Cover in Florida",
    "links": [
      {
        "name": "Miami",
        "url": "/lawyer-seo/miami-seo"
      },
      {
        "name": "Jacksonville",
        "url": "/lawyer-seo/jacksonville-seo"
      },
      {
        "name": "Orlando",
        "url": "/lawyer-seo/orlando-seo"
      },
      {
        "name": "Tampa",
        "url": "/lawyer-seo/tampa-seo"
      }
    ]
  },
  "fresno-seo": {
    "place": "Fresno",
    "title": "Fresno Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Fresno",
    "description": "Fresno lawyer and law firm SEO: rank in Fresno maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "More California Cities",
    "links": [
      {
        "name": "Los Angeles",
        "url": "/lawyer-seo/los-angeles-seo"
      },
      {
        "name": "San Francisco",
        "url": "/lawyer-seo/san-francisco-seo"
      },
      {
        "name": "San Diego",
        "url": "/lawyer-seo/san-diego-seo"
      },
      {
        "name": "Sacramento",
        "url": "/lawyer-seo/sacramento-seo"
      },
      {
        "name": "Santa Ana",
        "url": "/lawyer-seo/santa-ana-seo"
      },
      {
        "name": "Ventura County",
        "url": "/lawyer-seo/ventura-county-seo"
      },
      {
        "name": "San Bernardino",
        "url": "/lawyer-seo/san-bernardino-seo"
      },
      {
        "name": "Stockton",
        "url": "/lawyer-seo/stockton-seo"
      }
    ]
  },
  "georgia-seo": {
    "place": "Georgia",
    "title": "Georgia Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Georgia",
    "description": "Georgia lawyer and law firm SEO: rank across Georgia in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Cities We Cover in Georgia",
    "links": [
      {
        "name": "Atlanta",
        "url": "/lawyer-seo/atlanta-seo"
      }
    ]
  },
  "houston-seo": {
    "place": "Houston",
    "title": "Houston Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Houston",
    "description": "Houston lawyer and law firm SEO: rank in Houston maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Texas",
      "url": "/lawyer-seo/texas-seo"
    },
    "linksHeading": "More in Texas",
    "links": [
      {
        "name": "Texas",
        "url": "/lawyer-seo/texas-seo"
      },
      {
        "name": "Dallas",
        "url": "/lawyer-seo/dallas-seo"
      },
      {
        "name": "Austin",
        "url": "/lawyer-seo/austin-seo"
      },
      {
        "name": "San Antonio",
        "url": "/lawyer-seo/san-antonio-seo"
      }
    ],
    "caseStudy": {
      "title": "Case Study: A Houston Personal Injury Firm",
      "text": "A 9-attorney Houston personal injury firm went from page 4 to #1 for \"car accident lawyer Houston\" in 11 months, and organic consultations more than tripled in under a year.",
      "url": "/case-studies/personal-injury-houston"
    }
  },
  "illinois-seo": {
    "place": "Illinois",
    "title": "Illinois Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Illinois",
    "description": "Illinois lawyer and law firm SEO: rank across Illinois in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Cities We Cover in Illinois",
    "links": [
      {
        "name": "Chicago",
        "url": "/lawyer-seo/chicago-seo"
      },
      {
        "name": "Peoria",
        "url": "/lawyer-seo/peoria-seo"
      }
    ]
  },
  "indiana-seo": {
    "place": "Indiana",
    "title": "Indiana Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Indiana",
    "description": "Indiana lawyer and law firm SEO: rank across Indiana in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Indiana",
    "links": []
  },
  "iowa-seo": {
    "place": "Iowa",
    "title": "Iowa Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Iowa",
    "description": "Iowa lawyer and law firm SEO: rank across Iowa in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Iowa",
    "links": []
  },
  "jacksonville-seo": {
    "place": "Jacksonville",
    "title": "Jacksonville Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Jacksonville",
    "description": "Jacksonville lawyer and law firm SEO: rank in Jacksonville maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Florida",
      "url": "/lawyer-seo/florida-seo"
    },
    "linksHeading": "More in Florida",
    "links": [
      {
        "name": "Florida",
        "url": "/lawyer-seo/florida-seo"
      },
      {
        "name": "Miami",
        "url": "/lawyer-seo/miami-seo"
      },
      {
        "name": "Orlando",
        "url": "/lawyer-seo/orlando-seo"
      },
      {
        "name": "Tampa",
        "url": "/lawyer-seo/tampa-seo"
      }
    ]
  },
  "kansas-seo": {
    "place": "Kansas",
    "title": "Kansas Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Kansas",
    "description": "Kansas lawyer and law firm SEO: rank across Kansas in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Kansas",
    "links": []
  },
  "long-island-seo": {
    "place": "Long Island",
    "title": "Long Island Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Long Island",
    "description": "Long Island lawyer and law firm SEO: rank in Long Island maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "New York",
      "url": "/lawyer-seo/new-york-seo"
    },
    "linksHeading": "More in New York",
    "links": [
      {
        "name": "New York",
        "url": "/lawyer-seo/new-york-seo"
      }
    ]
  },
  "los-angeles-seo": {
    "place": "Los Angeles",
    "title": "Los Angeles Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Los Angeles",
    "description": "Los Angeles lawyer and law firm SEO: rank in Los Angeles maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "More California Cities",
    "links": [
      {
        "name": "San Francisco",
        "url": "/lawyer-seo/san-francisco-seo"
      },
      {
        "name": "San Diego",
        "url": "/lawyer-seo/san-diego-seo"
      },
      {
        "name": "Sacramento",
        "url": "/lawyer-seo/sacramento-seo"
      },
      {
        "name": "Santa Ana",
        "url": "/lawyer-seo/santa-ana-seo"
      },
      {
        "name": "Ventura County",
        "url": "/lawyer-seo/ventura-county-seo"
      },
      {
        "name": "San Bernardino",
        "url": "/lawyer-seo/san-bernardino-seo"
      },
      {
        "name": "Fresno",
        "url": "/lawyer-seo/fresno-seo"
      },
      {
        "name": "Stockton",
        "url": "/lawyer-seo/stockton-seo"
      }
    ]
  },
  "louisiana-seo": {
    "place": "Louisiana",
    "title": "Louisiana Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Louisiana",
    "description": "Louisiana lawyer and law firm SEO: rank across Louisiana in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Louisiana",
    "links": []
  },
  "maryland-seo": {
    "place": "Maryland",
    "title": "Maryland Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Maryland",
    "description": "Maryland lawyer and law firm SEO: rank across Maryland in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Maryland",
    "links": []
  },
  "miami-seo": {
    "place": "Miami",
    "title": "Miami Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Miami",
    "description": "Miami lawyer and law firm SEO: rank in Miami maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Florida",
      "url": "/lawyer-seo/florida-seo"
    },
    "linksHeading": "More in Florida",
    "links": [
      {
        "name": "Florida",
        "url": "/lawyer-seo/florida-seo"
      },
      {
        "name": "Jacksonville",
        "url": "/lawyer-seo/jacksonville-seo"
      },
      {
        "name": "Orlando",
        "url": "/lawyer-seo/orlando-seo"
      },
      {
        "name": "Tampa",
        "url": "/lawyer-seo/tampa-seo"
      }
    ]
  },
  "michigan-seo": {
    "place": "Michigan",
    "title": "Michigan Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Michigan",
    "description": "Michigan lawyer and law firm SEO: rank across Michigan in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Michigan",
    "links": []
  },
  "minnesota-seo": {
    "place": "Minnesota",
    "title": "Minnesota Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Minnesota",
    "description": "Minnesota lawyer and law firm SEO: rank across Minnesota in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Minnesota",
    "links": []
  },
  "montana-seo": {
    "place": "Montana",
    "title": "Montana Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Montana",
    "description": "Montana lawyer and law firm SEO: rank across Montana in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Montana",
    "links": []
  },
  "nevada-seo": {
    "place": "Nevada",
    "title": "Nevada Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Nevada",
    "description": "Nevada lawyer and law firm SEO: rank across Nevada in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Nevada",
    "links": []
  },
  "new-hampshire-seo": {
    "place": "New Hampshire",
    "title": "New Hampshire Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in New Hampshire",
    "description": "New Hampshire lawyer and law firm SEO: rank across New Hampshire in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across New Hampshire",
    "links": []
  },
  "new-mexico-seo": {
    "place": "New Mexico",
    "title": "New Mexico Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in New Mexico",
    "description": "New Mexico lawyer and law firm SEO: rank across New Mexico in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across New Mexico",
    "links": []
  },
  "new-york-seo": {
    "place": "New York",
    "title": "New York Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in New York",
    "description": "New York lawyer and law firm SEO: rank across New York in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Cities We Cover in New York",
    "links": [
      {
        "name": "Long Island",
        "url": "/lawyer-seo/long-island-seo"
      }
    ]
  },
  "north-carolina-seo": {
    "place": "North Carolina",
    "title": "North Carolina Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in North Carolina",
    "description": "North Carolina lawyer and law firm SEO: rank across North Carolina in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across North Carolina",
    "links": []
  },
  "north-dakota-seo": {
    "place": "North Dakota",
    "title": "North Dakota Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in North Dakota",
    "description": "North Dakota lawyer and law firm SEO: rank across North Dakota in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across North Dakota",
    "links": []
  },
  "ohio-seo": {
    "place": "Ohio",
    "title": "Ohio Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Ohio",
    "description": "Ohio lawyer and law firm SEO: rank across Ohio in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Cities We Cover in Ohio",
    "links": [
      {
        "name": "Cleveland",
        "url": "/lawyer-seo/cleveland-seo"
      }
    ]
  },
  "orlando-seo": {
    "place": "Orlando",
    "title": "Orlando Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Orlando",
    "description": "Orlando lawyer and law firm SEO: rank in Orlando maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Florida",
      "url": "/lawyer-seo/florida-seo"
    },
    "linksHeading": "More in Florida",
    "links": [
      {
        "name": "Florida",
        "url": "/lawyer-seo/florida-seo"
      },
      {
        "name": "Miami",
        "url": "/lawyer-seo/miami-seo"
      },
      {
        "name": "Jacksonville",
        "url": "/lawyer-seo/jacksonville-seo"
      },
      {
        "name": "Tampa",
        "url": "/lawyer-seo/tampa-seo"
      }
    ]
  },
  "pennsylvania-seo": {
    "place": "Pennsylvania",
    "title": "Pennsylvania Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Pennsylvania",
    "description": "Pennsylvania lawyer and law firm SEO: rank across Pennsylvania in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Cities We Cover in Pennsylvania",
    "links": [
      {
        "name": "Philadelphia",
        "url": "/lawyer-seo/philadelphia-seo"
      }
    ]
  },
  "peoria-seo": {
    "place": "Peoria",
    "title": "Peoria Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Peoria",
    "description": "Peoria lawyer and law firm SEO: rank in Peoria maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Illinois",
      "url": "/lawyer-seo/illinois-seo"
    },
    "linksHeading": "More in Illinois",
    "links": [
      {
        "name": "Illinois",
        "url": "/lawyer-seo/illinois-seo"
      },
      {
        "name": "Chicago",
        "url": "/lawyer-seo/chicago-seo"
      }
    ]
  },
  "philadelphia-seo": {
    "place": "Philadelphia",
    "title": "Philadelphia Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Philadelphia",
    "description": "Philadelphia lawyer and law firm SEO: rank in Philadelphia maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Pennsylvania",
      "url": "/lawyer-seo/pennsylvania-seo"
    },
    "linksHeading": "More in Pennsylvania",
    "links": [
      {
        "name": "Pennsylvania",
        "url": "/lawyer-seo/pennsylvania-seo"
      }
    ]
  },
  "phoenix-seo": {
    "place": "Phoenix",
    "title": "Phoenix Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Phoenix",
    "description": "Phoenix lawyer and law firm SEO: rank in Phoenix maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Arizona",
      "url": "/lawyer-seo/arizona-seo"
    },
    "linksHeading": "More in Arizona",
    "links": [
      {
        "name": "Arizona",
        "url": "/lawyer-seo/arizona-seo"
      },
      {
        "name": "Tucson",
        "url": "/lawyer-seo/tucson-seo"
      }
    ],
    "caseStudy": {
      "title": "Case Study: A Phoenix DUI Defense Attorney",
      "text": "A solo Phoenix DUI attorney grew after-hours mobile calls by 417% with a DUI-specific local strategy and cut paid search spend by 60%.",
      "url": "/case-studies/dui-defense-phoenix"
    }
  },
  "portland-seo": {
    "place": "Portland",
    "title": "Portland Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Portland",
    "description": "Portland lawyer and law firm SEO: rank in Portland maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Near Portland",
    "links": []
  },
  "sacramento-seo": {
    "place": "Sacramento",
    "title": "Sacramento Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Sacramento",
    "description": "Sacramento lawyer and law firm SEO: rank in Sacramento maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "More California Cities",
    "links": [
      {
        "name": "Los Angeles",
        "url": "/lawyer-seo/los-angeles-seo"
      },
      {
        "name": "San Francisco",
        "url": "/lawyer-seo/san-francisco-seo"
      },
      {
        "name": "San Diego",
        "url": "/lawyer-seo/san-diego-seo"
      },
      {
        "name": "Santa Ana",
        "url": "/lawyer-seo/santa-ana-seo"
      },
      {
        "name": "Ventura County",
        "url": "/lawyer-seo/ventura-county-seo"
      },
      {
        "name": "San Bernardino",
        "url": "/lawyer-seo/san-bernardino-seo"
      },
      {
        "name": "Fresno",
        "url": "/lawyer-seo/fresno-seo"
      },
      {
        "name": "Stockton",
        "url": "/lawyer-seo/stockton-seo"
      }
    ]
  },
  "san-antonio-seo": {
    "place": "San Antonio",
    "title": "San Antonio Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in San Antonio",
    "description": "San Antonio lawyer and law firm SEO: rank in San Antonio maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Texas",
      "url": "/lawyer-seo/texas-seo"
    },
    "linksHeading": "More in Texas",
    "links": [
      {
        "name": "Texas",
        "url": "/lawyer-seo/texas-seo"
      },
      {
        "name": "Houston",
        "url": "/lawyer-seo/houston-seo"
      },
      {
        "name": "Dallas",
        "url": "/lawyer-seo/dallas-seo"
      },
      {
        "name": "Austin",
        "url": "/lawyer-seo/austin-seo"
      }
    ]
  },
  "san-bernardino-seo": {
    "place": "San Bernardino",
    "title": "San Bernardino Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in San Bernardino",
    "description": "San Bernardino lawyer and law firm SEO: rank in San Bernardino maps and search for the cases you want, with signed-case reporting.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "More California Cities",
    "links": [
      {
        "name": "Los Angeles",
        "url": "/lawyer-seo/los-angeles-seo"
      },
      {
        "name": "San Francisco",
        "url": "/lawyer-seo/san-francisco-seo"
      },
      {
        "name": "San Diego",
        "url": "/lawyer-seo/san-diego-seo"
      },
      {
        "name": "Sacramento",
        "url": "/lawyer-seo/sacramento-seo"
      },
      {
        "name": "Santa Ana",
        "url": "/lawyer-seo/santa-ana-seo"
      },
      {
        "name": "Ventura County",
        "url": "/lawyer-seo/ventura-county-seo"
      },
      {
        "name": "Fresno",
        "url": "/lawyer-seo/fresno-seo"
      },
      {
        "name": "Stockton",
        "url": "/lawyer-seo/stockton-seo"
      }
    ]
  },
  "san-diego-seo": {
    "place": "San Diego",
    "title": "San Diego Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in San Diego",
    "description": "San Diego lawyer and law firm SEO: rank in San Diego maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "More California Cities",
    "links": [
      {
        "name": "Los Angeles",
        "url": "/lawyer-seo/los-angeles-seo"
      },
      {
        "name": "San Francisco",
        "url": "/lawyer-seo/san-francisco-seo"
      },
      {
        "name": "Sacramento",
        "url": "/lawyer-seo/sacramento-seo"
      },
      {
        "name": "Santa Ana",
        "url": "/lawyer-seo/santa-ana-seo"
      },
      {
        "name": "Ventura County",
        "url": "/lawyer-seo/ventura-county-seo"
      },
      {
        "name": "San Bernardino",
        "url": "/lawyer-seo/san-bernardino-seo"
      },
      {
        "name": "Fresno",
        "url": "/lawyer-seo/fresno-seo"
      },
      {
        "name": "Stockton",
        "url": "/lawyer-seo/stockton-seo"
      }
    ]
  },
  "san-francisco-seo": {
    "place": "San Francisco",
    "title": "San Francisco Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in San Francisco",
    "description": "San Francisco lawyer and law firm SEO: rank in San Francisco maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "More California Cities",
    "links": [
      {
        "name": "Los Angeles",
        "url": "/lawyer-seo/los-angeles-seo"
      },
      {
        "name": "San Diego",
        "url": "/lawyer-seo/san-diego-seo"
      },
      {
        "name": "Sacramento",
        "url": "/lawyer-seo/sacramento-seo"
      },
      {
        "name": "Santa Ana",
        "url": "/lawyer-seo/santa-ana-seo"
      },
      {
        "name": "Ventura County",
        "url": "/lawyer-seo/ventura-county-seo"
      },
      {
        "name": "San Bernardino",
        "url": "/lawyer-seo/san-bernardino-seo"
      },
      {
        "name": "Fresno",
        "url": "/lawyer-seo/fresno-seo"
      },
      {
        "name": "Stockton",
        "url": "/lawyer-seo/stockton-seo"
      }
    ]
  },
  "santa-ana-seo": {
    "place": "Santa Ana",
    "title": "Santa Ana Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Santa Ana",
    "description": "Santa Ana lawyer and law firm SEO: rank in Santa Ana maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "More California Cities",
    "links": [
      {
        "name": "Los Angeles",
        "url": "/lawyer-seo/los-angeles-seo"
      },
      {
        "name": "San Francisco",
        "url": "/lawyer-seo/san-francisco-seo"
      },
      {
        "name": "San Diego",
        "url": "/lawyer-seo/san-diego-seo"
      },
      {
        "name": "Sacramento",
        "url": "/lawyer-seo/sacramento-seo"
      },
      {
        "name": "Ventura County",
        "url": "/lawyer-seo/ventura-county-seo"
      },
      {
        "name": "San Bernardino",
        "url": "/lawyer-seo/san-bernardino-seo"
      },
      {
        "name": "Fresno",
        "url": "/lawyer-seo/fresno-seo"
      },
      {
        "name": "Stockton",
        "url": "/lawyer-seo/stockton-seo"
      }
    ]
  },
  "seattle-seo": {
    "place": "Seattle",
    "title": "Seattle Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Seattle",
    "description": "Seattle lawyer and law firm SEO: rank in Seattle maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Near Seattle",
    "links": []
  },
  "south-carolina-seo": {
    "place": "South Carolina",
    "title": "South Carolina Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in South Carolina",
    "description": "South Carolina lawyer and law firm SEO: rank across South Carolina in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across South Carolina",
    "links": []
  },
  "stockton-seo": {
    "place": "Stockton",
    "title": "Stockton Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Stockton",
    "description": "Stockton lawyer and law firm SEO: rank in Stockton maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "More California Cities",
    "links": [
      {
        "name": "Los Angeles",
        "url": "/lawyer-seo/los-angeles-seo"
      },
      {
        "name": "San Francisco",
        "url": "/lawyer-seo/san-francisco-seo"
      },
      {
        "name": "San Diego",
        "url": "/lawyer-seo/san-diego-seo"
      },
      {
        "name": "Sacramento",
        "url": "/lawyer-seo/sacramento-seo"
      },
      {
        "name": "Santa Ana",
        "url": "/lawyer-seo/santa-ana-seo"
      },
      {
        "name": "Ventura County",
        "url": "/lawyer-seo/ventura-county-seo"
      },
      {
        "name": "San Bernardino",
        "url": "/lawyer-seo/san-bernardino-seo"
      },
      {
        "name": "Fresno",
        "url": "/lawyer-seo/fresno-seo"
      }
    ]
  },
  "tampa-seo": {
    "place": "Tampa",
    "title": "Tampa Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Tampa",
    "description": "Tampa lawyer and law firm SEO: rank in Tampa maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Florida",
      "url": "/lawyer-seo/florida-seo"
    },
    "linksHeading": "More in Florida",
    "links": [
      {
        "name": "Florida",
        "url": "/lawyer-seo/florida-seo"
      },
      {
        "name": "Miami",
        "url": "/lawyer-seo/miami-seo"
      },
      {
        "name": "Jacksonville",
        "url": "/lawyer-seo/jacksonville-seo"
      },
      {
        "name": "Orlando",
        "url": "/lawyer-seo/orlando-seo"
      }
    ]
  },
  "tennessee-seo": {
    "place": "Tennessee",
    "title": "Tennessee Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Tennessee",
    "description": "Tennessee lawyer and law firm SEO: rank across Tennessee in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Tennessee",
    "links": []
  },
  "texas-seo": {
    "place": "Texas",
    "title": "Texas Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Texas",
    "description": "Texas lawyer and law firm SEO: rank across Texas in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Cities We Cover in Texas",
    "links": [
      {
        "name": "Houston",
        "url": "/lawyer-seo/houston-seo"
      },
      {
        "name": "Dallas",
        "url": "/lawyer-seo/dallas-seo"
      },
      {
        "name": "Austin",
        "url": "/lawyer-seo/austin-seo"
      },
      {
        "name": "San Antonio",
        "url": "/lawyer-seo/san-antonio-seo"
      }
    ]
  },
  "tucson-seo": {
    "place": "Tucson",
    "title": "Tucson Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Tucson",
    "description": "Tucson lawyer and law firm SEO: rank in Tucson maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": {
      "name": "Arizona",
      "url": "/lawyer-seo/arizona-seo"
    },
    "linksHeading": "More in Arizona",
    "links": [
      {
        "name": "Arizona",
        "url": "/lawyer-seo/arizona-seo"
      },
      {
        "name": "Phoenix",
        "url": "/lawyer-seo/phoenix-seo"
      }
    ]
  },
  "tulsa-seo": {
    "place": "Tulsa",
    "title": "Tulsa Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Tulsa",
    "description": "Tulsa lawyer and law firm SEO: rank in Tulsa maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Near Tulsa",
    "links": []
  },
  "ventura-county-seo": {
    "place": "Ventura County",
    "title": "Ventura County Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Ventura County",
    "description": "Ventura County lawyer and law firm SEO: rank in Ventura County maps and search for the cases you want, with signed-case reporting.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "More California Cities",
    "links": [
      {
        "name": "Los Angeles",
        "url": "/lawyer-seo/los-angeles-seo"
      },
      {
        "name": "San Francisco",
        "url": "/lawyer-seo/san-francisco-seo"
      },
      {
        "name": "San Diego",
        "url": "/lawyer-seo/san-diego-seo"
      },
      {
        "name": "Sacramento",
        "url": "/lawyer-seo/sacramento-seo"
      },
      {
        "name": "Santa Ana",
        "url": "/lawyer-seo/santa-ana-seo"
      },
      {
        "name": "San Bernardino",
        "url": "/lawyer-seo/san-bernardino-seo"
      },
      {
        "name": "Fresno",
        "url": "/lawyer-seo/fresno-seo"
      },
      {
        "name": "Stockton",
        "url": "/lawyer-seo/stockton-seo"
      }
    ]
  },
  "vermont-seo": {
    "place": "Vermont",
    "title": "Vermont Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Vermont",
    "description": "Vermont lawyer and law firm SEO: rank across Vermont in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Vermont",
    "links": []
  },
  "virginia-seo": {
    "place": "Virginia",
    "title": "Virginia Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Virginia",
    "description": "Virginia lawyer and law firm SEO: rank across Virginia in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Virginia",
    "links": []
  },
  "washington-dc-seo": {
    "place": "Washington DC",
    "title": "Washington DC Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Washington DC",
    "description": "Washington DC lawyer and law firm SEO: rank across Washington DC in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "City",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Washington DC",
    "links": []
  },
  "west-virginia-seo": {
    "place": "West Virginia",
    "title": "West Virginia Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in West Virginia",
    "description": "West Virginia lawyer and law firm SEO: rank across West Virginia in maps and search for the cases you want, with signed-case reporting.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across West Virginia",
    "links": []
  },
  "wisconsin-seo": {
    "place": "Wisconsin",
    "title": "Wisconsin Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Wisconsin",
    "description": "Wisconsin lawyer and law firm SEO: rank across Wisconsin in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Wisconsin",
    "links": []
  },
  "wyoming-seo": {
    "place": "Wyoming",
    "title": "Wyoming Lawyer & Law Firm SEO | PageOne Lawyers",
    "h1": "Lawyer & Law Firm SEO in Wyoming",
    "description": "Wyoming lawyer and law firm SEO: rank across Wyoming in maps and search for the cases you want, with reporting on calls and signed cases.",
    "areaType": "State",
    "breadcrumbParent": null,
    "linksHeading": "Lawyer & Law Firm SEO Across Wyoming",
    "links": []
  }
};
